ObjectUtils.define('Runtime', {

  codeVersion: '',
  areLinksAsync: false,

  init: function init(appData) {
    this.appData = appData;
    this.codeVersion = appData.codeVersion;
    this.authToken = appData.authToken;
    this.areLinksAsync = true;

    Page.init();

    // This helps some mobile modules initialize correctly (e.g. RollbarLogger)
    if (appData.uid) {
      NotificationManager.trigger('Session.UPDATE', {
        uid: appData.uid,
        email: appData['user.email'],
      });
    }
  },

  getType: function getType() {
    return 'desktop';
  },

  getClientStateAsString: function getClientStateAsString() {
    return ObjectUtils.toJS({
      device: 'browser',
    });
  },

  getAppData: function getAppData(key) {
    if (!(key in this.appData)) {
      Assert.FAIL('Missing key in app data ['+key+']');
    }
    return this.appData[key];
  },

  isDev: function isDev() {
    return this.codeVersion === 'dev';
  },

  getUid: function getUid() {
    if (!this.appData || !this.appData.uid) {
      return null;
    }

    return this.appData.uid;
  },

});

